<script>
    import Vue from 'vue';
    import VueButton from '~/components/button/components/button';
    import VueCroppie from 'vue-croppie';
    import { Dialog } from 'element-ui';

    Vue.use(VueCroppie);
    Vue.use(Dialog);

    export default {

        components: {
            VueButton
        },

        props: {
            title: {
                type: String,
                default: 'Image Cropper'
            },

            cropperVisible: {
                required: true
            },
            url: {
                required: true
            },
            modalLoading: {
                default: false
            },

            type: {
                type: String,
                required: true
            },

            format: {
                type: String,
                required: true
            },

            circle: {
                type: Boolean,
                required: true
            },

            viewport: {
                type: Object,
                required: true
            },

            boundary: {
                type: Object,
                required: true
            },

            allowCrop: {
                type: Boolean,
                default: true
            },

            useCroppie: {
                type: Boolean,
                default: true
            },

            staticImageSrc: {
                type: String,
                default: ''
            }
        },

        computed: {
            croppieOptions() {
                return {
                    type: this.type,
                    size: 'viewport',
                    format: this.format,
                    circle: this.circle
                };
            }
        },

        watch: {
            cropperVisible(isVisible) {
                if(isVisible) {
                    document.body.appendChild(this.$el);
                } else if(this.$el && this.$el.parentNode) {
                    this.$el.parentNode.removeChild(this.$el);
                }
            }
        },

        methods: {
            crop() {
                if(this.useCroppie) {
                    this.$refs.croppieRef.result(this.croppieOptions).then(output => {
                        this.$emit('input', output);
                    });
                } else {
                    this.$emit('input', this.staticImageSrc);
                }

                this.closeModal();
            },

            openModal() {
                if(this.useCroppie) {
                    setTimeout( () => {
                        this.$refs.croppieRef.bind({
                            url: this.url
                        });
                    }, 300);
                }
            },
            closeModal() {
                this.$emit('update:cropperVisible', false);
            },
        }
    }
</script>

<template>
    <el-dialog
        :title="title"
        :visible.sync="cropperVisible"
        :close-on-click-modal="false"
        :show-close="false"
        :close-on-press-escape="false"
        @open="openModal"
        >
        <div class="fade in">
            <loader :isLoading="modalLoading"></loader>
            <template  v-if="useCroppie">
                <vue-croppie
                    ref="croppieRef"
                    :enableResize="allowCrop"
                    :enableExif="true"
                    :viewport="viewport"
                    :boundary="boundary"
                    >
                </vue-croppie>
            </template>
            <template v-else>
                <img class="img-responsive" :src="staticImageSrc" />
            </template>
        </div>
        <div slot="footer">
            <vue-button
                type="white"
                size="sm"
                @click="closeModal"
                >
                Cancel
            </vue-button>
            <vue-button
                type="primary"
                size="sm"
                @click="crop"
                >
                Save
            </vue-button>
        </div>
    </el-dialog>
</template>
